/**
 * Generated by tooling/scripts/extract-design-tokens.mjs from GUI_Design/design/02 Console Shell v3.dc.html.
 * Do not edit by hand: the design files are the approved source and these values are read from them.
 *
 * Tokens introduced by one screen rather than by the shell: --mapBase (05 Dispatch Live Map), --mapGrid (05 Dispatch Live Map), --mapRoad (05 Dispatch Live Map), --mapRoadEdge (05 Dispatch Live Map), --mapPark (05 Dispatch Live Map).
 */
export const lightTokens = {
    "--surface": "#FFFFFF",
    "--canvas": "#F6F7F9",
    "--sunken": "#F9FAFB",
    "--text": "#101828",
    "--text2": "#475467",
    "--text2b": "#344054",
    "--text3": "#667085",
    "--border": "#EAECF0",
    "--strong": "#D0D5DD",
    "--muted": "#F2F4F7",
    "--selected": "#F5F7FF",
    "--accentTint": "#EEF2FF",
    "--t-violet": "#F4F3FF",
    "--t-red": "#FEF3F2",
    "--t-sky": "#F0F9FF",
    "--t-amber": "#FFFAEB",
    "--t-green": "#ECFDF3",
    "--humanRow": "#FAF8FF",
    "--failRow": "#FFFBFA",
    "--amberText": "#93370D",
    "--inkBtn": "#101828",
    "--inkBtnText": "#FFFFFF",
    "--s-danger-fg": "#B42318",
    "--s-danger-ring": "#FECDCA",
    "--s-warning-fg": "#B54708",
    "--s-warning-ring": "#FEDF89",
    "--s-attention-fg": "#6941C6",
    "--s-attention-ring": "#D9D6FE",
    "--s-success-fg": "#067647",
    "--s-success-ring": "#ABEFC6",
    "--s-info-fg": "#026AA2",
    "--s-info-ring": "#B9E6FE",
    "--s-neutral-fg": "#475467",
    "--s-neutral-ring": "#E4E7EC",
    "--pageBg": "#EEF0F4",
    "--nav": "#0C111D",
    "--navEdge": "transparent",
    "--navItem": "#161B26",
    "--navActive": "#1F242F",
    "--topbar": "#FFFFFF",
    "--mapBase": "#EEF1F4",
    "--mapGrid": "#E3E7EC",
    "--mapRoad": "#FFFFFF",
    "--mapRoadEdge": "#DCE1E8",
    "--mapPark": "#DDEFE3",
    "--s-danger-tint": "#FEF3F2",
    "--s-danger-solid": "#D92D20",
    "--s-warning-tint": "#FFFAEB",
    "--s-attention-tint": "#F4F3FF",
    "--s-attention-solid": "#7C3AED",
    "--s-success-tint": "#ECFDF3",
    "--s-info-tint": "#F0F9FF",
    "--s-neutral-tint": "#F2F4F7",
    "--action": "#3E63DD",
    "--action-hover": "#2F4FB8",
};
export const darkTokens = {
    "--surface": "#171D29",
    "--canvas": "#0F141E",
    "--sunken": "#131925",
    "--text": "#F5F5F6",
    "--text2": "#CECFD2",
    "--text2b": "#E4E7EC",
    "--text3": "#94969C",
    "--border": "#262D3A",
    "--strong": "#3A4253",
    "--muted": "#212835",
    "--selected": "#1D2740",
    "--accentTint": "#1D2740",
    "--t-violet": "#261A45",
    "--t-red": "#3B1512",
    "--t-sky": "#0B2536",
    "--t-amber": "#35240A",
    "--t-green": "#0B2A1C",
    "--humanRow": "#1B1630",
    "--failRow": "#22141A",
    "--amberText": "#FEC84B",
    "--inkBtn": "#F5F5F6",
    "--inkBtnText": "#0C111D",
    "--s-danger-fg": "#FDA29B",
    "--s-danger-ring": "#55160C",
    "--s-warning-fg": "#FEC84B",
    "--s-warning-ring": "#4E3400",
    "--s-attention-fg": "#BDB4FE",
    "--s-attention-ring": "#3E1C96",
    "--s-success-fg": "#75E0A7",
    "--s-success-ring": "#074D31",
    "--s-info-fg": "#7CD4FD",
    "--s-info-ring": "#0B4A6F",
    "--s-neutral-fg": "#CECFD2",
    "--s-neutral-ring": "#333741",
    "--pageBg": "#05070C",
    "--nav": "#070A10",
    "--navEdge": "#232A37",
    "--navItem": "#151B27",
    "--navActive": "#1E2636",
    "--topbar": "#121823",
    "--mapBase": "#111827",
    "--mapGrid": "#1A2230",
    "--mapRoad": "#243044",
    "--mapRoadEdge": "#2C3A52",
    "--mapPark": "#12281F",
    "--s-danger-tint": "#3B1512",
    "--s-danger-solid": "#D92D20",
    "--s-warning-tint": "#35240A",
    "--s-attention-tint": "#261A45",
    "--s-attention-solid": "#7C3AED",
    "--s-success-tint": "#0B2A1C",
    "--s-info-tint": "#0B2536",
    "--s-neutral-tint": "#1F242F",
    "--action": "#3E63DD",
    "--action-hover": "#2F4FB8",
};
/** The token names, so a caller can iterate them without depending on object order. */
export const designTokenNames = Object.keys(lightTokens);
//# sourceMappingURL=tokens.js.map